var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.video_player},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered"})])}
var staticRenderFns = []

export { render, staticRenderFns }